<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

defineProps({
    diarios: Array,
    columnas: Array
});

const rutaPrefijo = ref('diario');
const modulo = ref('diario');
const modulos = ref('Diario de asistencia');// <-- titulo del listado
</script>

<template>

    <Head title="Diario" />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader title="Diario de asistencia" subtitle="Gestión de diario de asistencia">
        </PremiumPageHeader>
    </template>

        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <CardBox v-if="diarios.length" class="mb-6" has-table>
                    <!-- Tablesingle opciones: checkable -->
                    <div class="w-full overflow-x-auto relative">
                        <TableAdvancedFilter :modulo="modulo" :modulos="modulos" :data="diarios" :fields="columnas" :ruta="rutaPrefijo" exporteable /><!-- exporteable updateable visualable -->
                    </div>

                </CardBox>
                <CardBox v-else>
                    <CardBoxComponentEmpty />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
